import { IGetPesquisaSatisfacaoDropDownUseCase } from "../../../presentation/useCases/read/get_pesquisa_satisfacao_drop_down_use_case";
import { PesquisaSatisfacaoDropDown } from "../../models/pesquisa_satisfacao_dropdown";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetPesquisaSatisfacaoDropDownUseCase
 */

export class GetPesquisaSatisfacaoDropDownUseCase implements IGetPesquisaSatisfacaoDropDownUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getPesquisaSatisfacaoDropDown(
  ): Promise<PesquisaSatisfacaoDropDown[]> {
    return this.repository.getPesquisaSatisfacaoDropDown();
  }
}
